import React, { FC } from 'react';
import { Box, Container, Grid, Link, Theme, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { SocialMediaButton } from 'components/atoms';
import { FacebookShareButton, LinkedinShareButton } from 'react-share';
import { NewsSinglePost } from 'services/news/types';
import { FbDarkIcon, InstagramDarkIcon, LnDarkIcon } from 'svgs';
import { INSTAGRAM, INSTAGRAM_LINK } from '../../config';

interface NewsSocialMediaSection {
  post: NewsSinglePost;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginBottom: theme.spacing(20),
  },
  divider: {
    width: '100%',
    height: 1,
    backgroundColor: theme.palette.secondary.light,
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  button: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#F5F5F5 !important',
    fontWeight: 400,
    border: '1px solid #EBEBED !important',
    minHeight: 46,
    color: 'transparent !important',
    boxShadow: 'none',
    padding: `12px 32px !important`,
    marginBottom: `${theme.spacing(2)}px !important`,
    '&:hover': {
      color: 'transparent',
      backgroundColor: '#FAFAFA',
    },
  },
  title: {
    fontWeight: 500,
    paddingLeft: theme.spacing(1),
  },
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    gap: 24,
    '& > * ': {
      flexGrow: 1,
      width: '100%',
    },
    '& > p': {
      minWidth: 100,
      maxWidth: 100,
    },
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
  },
}));

const NewsSocialMediaSection: FC<NewsSocialMediaSection> = (props) => {
  const classes = useStyles();
  const { post } = props;
  const link = typeof location !== 'undefined' ? location.href : '';

  return (
    <Container fixed className={classes.root}>
      <Grid container justifyContent="center" direction="row">
        <Grid md={8} xs={12} item>
          <Box className={classes.wrapper}>
            <Typography>Read About:</Typography>
            <Link href={post.facebook_link} target={'_blank'}>
              <SocialMediaButton text="Facebook" isFb />
            </Link>
            <Link href={post.linkedin_link} target={'_blank'}>
              <SocialMediaButton text="LinkedIn" isLn />
            </Link>
            <Link href={post.instagram_link || INSTAGRAM_LINK} target={'_blank'}>
              <SocialMediaButton text="Instagram" isIn />
            </Link>
          </Box>

          <Box className={classes.divider} />

          <Box className={classes.wrapper}>
            <Typography>Share Via:</Typography>
            <FacebookShareButton url={link} className={classes.button}>
              <FbDarkIcon />
              <Typography variant="body1" color="textSecondary" className={classes.title}>
                Facebook
              </Typography>
            </FacebookShareButton>
            <LinkedinShareButton url={link} className={classes.button}>
              <LnDarkIcon />
              <Typography variant="body1" color="textSecondary" className={classes.title}>
                LinkedIn
              </Typography>
            </LinkedinShareButton>
            <Link href={INSTAGRAM} className={classes.button} target={'_blank'}>
              <InstagramDarkIcon />
              <Typography variant="body1" color="textSecondary" className={classes.title}>
                Instagram
              </Typography>
            </Link>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default NewsSocialMediaSection;
